import { IconBoxDevice } from "../../components/Icons/Icons";
import styles from "./PageProjectDetail.module.css";

export const ManagerInfoTab = ({ fundData }) => {
  return (
    <div
      className="page-security-head"
      style={{
        padding: "5px 0px 0px",
        display: "flex",
        flexDirection: "column",
      }}
    >
      <div className="page-security-subtitle" style={{ display: "flex", alignItems: "center", margin: "15px 0" }}>
        <IconBoxDevice
          colorIcon="#1b4ec1"
          height="15px"
          width="15px"
        />
        <span style={{ marginLeft: "10px" }}>Sobre el Administrador</span>
      </div>

      <div className="d-flex">
        <img
          src={fundData?.image || fundData?.imagen || "https://picsum.photos/200/150"}
          alt="Acción Fiduciaria"
          height="150px"
          style={{ borderRadius: "8px", marginRight: "10px", objectFit: "cover", width: "200px" }}
        />
        <p
          style={{ textAlign: "left" }}
          className={`mr-5 ${styles.infoTecBoxText}`}
        >
          ACCION FIDUCIARIA es su aliado en soluciones personalizadas e innovadoras para la administración eficiente de inversiones, activos, recursos y proyectos. Gestionamos con flexibilidad, rapidez y transparencia los proyectos de nuestros clientes para alcanzar sus objetivos.
        </p>
      </div>
    </div>
  );
};
